import React from 'react';
import Modal from './layout/Modal';
import VBox from './layout/VBox';
import Descricao from './tipografia/Descricao';
import Botao from './Botao';
import { mdiRocketLaunch } from '@mdi/js';
import { useNavigate } from 'react-router-dom';

type FreeTierModalProps = {
    show: boolean;
    onClose: () => void;
    feature?: string;
};

const FreeTierModal: React.FC<FreeTierModalProps> = ({
    show,
    onClose,
    feature = 'todas as funcionalidades'
}) => {
    const navigate = useNavigate();

    const handleUpgradeClick = () => {
        onClose();
        navigate('/upgrade-plano');
    };

    return (
        <Modal
            size="md"
            title="Plano gratuito"
            show={show}
            onClose={onClose}
            onCancel={onClose}
            confirmProps={{ label: 'Entendi. Fechar' }}
        >
            <div style={{ padding: '16px' }}>
                <VBox gap="16px">
                    <Descricao>
                        Seu plano atual é o plano gratuito, que possui limitações de uso.
                    </Descricao>
                    <Descricao>
                        Para desbloquear {feature}, considere atualizar seu plano.
                    </Descricao>
                    <Botao
                        variant="primary"
                        icon={mdiRocketLaunch}
                        onClick={handleUpgradeClick}
                        style={{ marginTop: '8px' }}
                    >
                        Ver Planos e Fazer Upgrade
                    </Botao>
                    <div style={{ fontSize: '12px', color: 'var(--tc-color-gray-600)' }}>
                        Caso tenha dúvidas sobre os planos disponíveis, entre em contato com nossa equipe de suporte.
                    </div>
                </VBox>
            </div>
        </Modal>
    );
};

export default FreeTierModal;
